import Vue from 'vue'
import Router from 'vue-router'
import PrbLanding from '@/components/PrbLanding'
import PrbAbout from '@/components/PrbAbout'
import PrbFaq from '@/components/PrbFaq'
import PrbContact from '@/components/PrbContact'
import PrbLimitations from '@/components/PrbLimitations'
import PrbTutorial from '@/components/PrbTutorial'
import PrbDownload from '@/components/PrbDownload'
import PrbCompoundSynopsis from '@/components/PrbCompoundSynopsis'
import PrbCompoundsAll from '@/components/PrbCompoundsAll'
import PrbSingleCompoundSynopsis from '@/components/PrbSingleCompoundSynopsis'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'prblanding',
      component: PrbLanding
    },
    {
      path: '/about',
      name: 'prbabout',
      component: PrbAbout
    },
    {
      path: '/contact',
      name: 'prbcontact',
      component: PrbContact
    },
    {
      path: '/limitations',
      name: 'prblimitations',
      component: PrbLimitations
    },
    {
      path: '/tutorial',
      name: 'prbtutorial',
      component: PrbTutorial
    },
    {
      path: '/download',
      name: 'prbdownload',
      component: PrbDownload
    },
    {
      path: '/faq',
      name: 'prbfaq',
      component: PrbFaq
    },
    { path: '/:id',
      name: 'prbcompoundsynopsis',
      component: PrbCompoundSynopsis
    },
    { path: '/:id/compounds',
      name: 'prbcompoundsall',
      component: PrbCompoundsAll
    },
    { path: '/:id/:compound',
      name: 'prbsinglecompoundsynopsis',
      component: PrbSingleCompoundSynopsis
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js